import { render, staticRenderFns } from "./CustomerOrdersUpcoming.vue?vue&type=template&id=29fc6a78&"
import script from "./CustomerOrdersUpcoming.vue?vue&type=script&lang=ts&"
export * from "./CustomerOrdersUpcoming.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports